module.exports = __webpack_public_path__ + "assets/img/031.55bb02ea.jpg";